{
    "roadmap": {
        "common": {
            "openAll": "Nyisd meg mindet",
            "closeAll": "Zárd be mindet",
            "openorCloseTitle": "Nyisd meg vagy zárd be mindet"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Mi az a NextGen IT? Elhozzuk az IT-automatizálást közvetlenül neked, hogy gyorsabban megoldjuk a problémákat.",
            "acc1Title": "Élesben",
            "prodItem1": "KB-cikk integráció: 300+ KB-cikk segít, hogy magad is megoldj IT-gondokat.",
            "prodItem2": "Önjavító megoldás: 18+ távoli szkript segít gyorsan megoldani a gondokat.",
            "prodItem3": "Incidens létrehozása: Az automatikus incidensnaplózás pontosabb és gyorsabb megoldást hoz.",
            "prodItem4": "Csevegés élő ügynökkel (valódi emberrel): A MyHelp AI-asszisztensből egy kattintással átválthatsz emberi ügynökre.",
            "acc2Title": "Készülőben",
            "devItem1": "Visszahívás időzítése (2026. február): Időzíts egy IT-támogatási visszahívást egy neked megfelelő időpontra.",
            "devItem2": "Intelligens útvonaltervezés (2026. február): A jegyeket a megfelelő megoldócsapathoz irányítjuk, hogy gyorsabban kapj segítséget.",
            "acc3Title": "Hátralék",
            "backItem1": "PKI-hibaelhárító ügynök: MyHelp-integráció a PKI-hibaelhárítóval, hogy megoldjuk a tanúsítványos gondokat.",
            "backItem2": "Walk-in központi időpontok ütemezése közvetlenül a MyHelpben."
        },
        "corporate": {
            "title": "Vállalati",
            "desc": "A Vállalati csapat kezeli a vállalati appokat és HR-platformokat, amik támogatják a csapatokat és az üzleti működést.",
            "acc1Title": "Élesben",
            "prodItem1": "Üzleti egység alapú appok: 90+ app BU-s személyre szabással.",
            "prodItem2": "Egyéni app rögzítése: Testreszabhatod a MyHelp irányítópultod egyéni appok rögzítésével.",
            "prodItem3": "Munkahelyi kérdések: 100+ kérdés irodáról, parkolásról, épületekről.",
            "prodItem4": "Tárgyalófoglalás AI-asszisztenssel: Gyors, egyszerű foglalás Gingco-integrációval.",
            "prodItem5": "HR-kérdések: A MyHelp megválaszolja a top 50 HR-kérdést.",
            "prodItem6": "Kollégakereső: A MyHelpben rákereshetsz E.ON-os kollégákra.",
            "acc2Title": "Készülőben",
            "devItem1": "Appok bevezetése üzleti egységenként.",
            "devItem2": "Tárgyaló AI-asszisztens",
            "acc3Title": "Hátralékban",
            "backItem1": "Appok hozzáadása az AI-asszisztensből és egyéni lapokról: Appokat azonnal hozzáadhatsz a MyHelp Asszisztens ajánlásai alapján."
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Ezzel az integrációval gyorsan megtalálod a hozzád passzoló képzéseket és kurzusokat.",
            "acc1Title": "Élesben",
            "prodItem1": "Képzések és kurzusok keresése: Találd meg a releváns képzéseket és kurzusokat a MyHelpben.",
            "acc2Title": "Készülőben",
            "acc3Title": "Hátralékban",
            "backItem1": "Személyre szabott tanulás: Személyre szabott képzési ajánlások a BU-jogosultságod alapján."
        },
        "myItOrder": {
            "title": "MyIT rendelés",
            "desc": "Segít megtalálni a releváns IT-rendelési tételeket és katalógusokat.",
            "acc1Title": "Élesben",
            "prodItem1": "Gyors IT-rendelési katalóguskeresés: Keress és rendelj gyorsan IT-tételeket a MyHelpben.",
            "prodItem2": "Szoftverhozzáférés adása és visszavonása: Adj vagy vonj vissza hozzáférést a MyHelpből.",
            "acc2Title": "Készülőben",
            "devItem1": "IT-eszközök költségáttekintése: A MyHelp megmutatja az IT-eszközök költségeit.",
            "acc3Title": "Hátralékban",
            "backItem1": "Rendelések központi jóváhagyása."
        },
        "compass": {
            "title": "Iránytű",
            "desc": "Segít megtalálni az intraneten megosztott közösségi posztokat, híreket és bejelentéseket.",
            "acc1Title": "Élesben",
            "prodItem1": "Megjelenik 2026. február 28-án.",
            "acc2Title": "Készülőben",
            "devItem1": "Iránytű-keresés (2026. február): E.ON-os felhasználók rákereshetnek a közösségi tartalmaikra a MyHelp E.ON keresőben.",
            "devItem2": "MyHelp–Iránytű AI-asszisztens (folyamatban) (2026. február): E.ON-os felhasználók a MyHelp AI-asszisztensen keresztül elérik a közösségi adataikat.",
            "acc3Title": "Hátralékban"
        },
        "chatProjectData": {
            "title": "Csevegés a projektadataiddal",
            "desc": "Ez az integráció lehetővé teszi, hogy a projektadataidat Confluence-, SharePoint- stb. helyekről behúzd.",
            "acc1Title": "Élesben",
            "prodItem1": "Confluence One Billing és DSODP projektek bekötve.",
            "prodItem2": "SharePoint-helyek – DSODP projektoldal bekötve.",
            "acc2Title": "Készülőben",
            "devItem1": "A Nautilus projekt adatainak integrálása folyamatban.",
            "acc3Title": "Hátralékban"
        },
        "personalization": {
            "title": "Személyre szabás",
            "acc1Title": "Élesben",
            "prodItem1": "Többnyelvű: 4 nyelvet támogat (angol, német, svéd, román).",
            "prodItem2": "Több téma: Minden üzleti egység vagy régió használhatja a saját márkáját, hogy otthonosabb legyen és könnyebb legyen megszokni.",
            "prodItem3": "Még 5 új nyelv béta profilban (cseh, olasz, magyar, holland és lengyel).",
            "acc2Title": "Készülőben",
            "devItem1": "Adatforrás-specifikus (2026. február 15.): Célzottabb, kontextusérzékenyebb válaszok az általad kiválasztott adatforrások alapján.",
            "acc3Title": "Hátralékban"
        },
        "technicalEnablement": {
            "title": "Technikai engedélyezés",
            "acc1Title": "Élesben",
            "prodItem1": "Biztonság és megfigyelhetőség: Vállalati szintű adatvédelem, megfelelés és teljesítmény, hogy minden biztonságosan, megbízhatóan és zökkenőmentesen menjen.",
            "prodItem2": "KPI- és elfogadási irányítópultok (Power BI)<br /> Átláthatóvá tesszük a használatot, az értékteremtést és az üzleti hatást a KPI-irányítópultokon.",
            "acc2Title": "Készülőben",
            "devItem1": "Többügynökös munkafolyamat (2026. március 15.): Szándékvezérelt beszélgetések, amik nemcsak relevánsabb válaszokat adnak, hanem end-to-end le is vezénylik a feladatokat neked.",
            "acc3Title": "Hátralékban",
            "backItem1": "MCP-keretrendszer (hátralék): <br /> Alapot ad az AI-ügynökök E.ON-on belüli összehangolásához és koordinálásához, lehetővé téve a skálázható, együttműködő vállalati AI-képességeket."
        }
    }
}